<template>
    <v-card>
        <v-card-title>Add affected sites</v-card-title>

        <v-divider />

        <v-card-text >

            <v-text-field class="mb-8" color="#c42111" v-model="siteSearch" append-icon="mdi-magnify" label="Site Search" single-line hide-details></v-text-field>
            <div id="sites-list">
                <v-data-table v-model="selectedSites" :items-per-page="$props.sitesList.length" hide-default-footer item-key="site_id" :headers="siteHeaders" :items="$props.sitesList" :search="siteSearch" show-select v-if="showList" />
            </div>
            
        </v-card-text>

        <v-divider />

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="mr-3" @click="$emit('cancel')">Cancel</v-btn>
            <v-btn text @click="$emit('ok', selectedSites)">Ok</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'AddSiteAffected',
    props: ['sitesList'],
    components: {
    },
    data: () => ({
        siteSearch: '',
        selectedSites: [],
        siteHeaders: [
            {text: 'Office', value: 'site_office', align: 'start'},
            {text: 'Location', value: 'site_location'},
            {text: 'Site Name', value: 'site_name'},
        ],
        showList: true,
    }),

    computed: {

    },

    methods: {
    },

    mounted() {
    },
  
};
</script>

<style scoped>

    #sites-list {
        height: 600px;
        max-height: 580px;
        overflow: auto;
    }

</style>

